import Authenticator from './Authenticator.vue'
import Email from './Email.vue'
import Sms from './Sms.vue'
export default {
  Authenticator,
  Email,
  Sms
}
